module.exports = __webpack_public_path__ + "static/img/3.eef34931.jpeg";